export default {
  cancelText: '取消',
  confirmText: '确定',
  title: '请选择',
};
